import Tag from '../reusable/Tag';

interface SurveyReportStatusProps {
  status: string | null;
  size?: 'small' | 'medium';
  className?: string;
}

export const getSurveyReportStatusDisplay = (
  status: string | null
): { text: string; type: 'pending' | 'completed' | 'progress' | 'error' } => {
  switch (status) {
    case 'SURVEYS_NOT_STARTED':
      return { text: 'Not started', type: 'pending' };
    case 'SURVEYS_OPEN':
      return { text: 'Surveys Open', type: 'progress' };
    case 'SURVEYS_CLOSED':
      return { text: 'Surveys Closed', type: 'progress' };
    case 'SURVEY_REPORT_GENERATED':
      return { text: 'Report Generated', type: 'progress' };
    case 'SURVEY_REPORT_REJECTED':
    case 'SURVEY_REPORT_GENERATION_FAILED':
    case 'SURVEY_REPORT_GENERATION_IN_PROGRESS':
      return { text: 'Report Generation in Progress', type: 'progress' };
    case 'SURVEY_REPORT_FINALIZED':
      return { text: 'Completed', type: 'completed' };
    default:
      return { text: status || 'Not started', type: 'pending' };
  }
};

const SurveyReportStatus = ({ status, size = 'small', className }: SurveyReportStatusProps) => {
  const { text, type } = getSurveyReportStatusDisplay(status);
  return <Tag type={type} text={text} size={size} className={className} />;
};

export default SurveyReportStatus;
